<template>
  <div class="content-body tenant-settings">
    <div class="">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="协议编码:" label-width="86px">
          <el-input size="small" v-model="dataForm.priceAgreementCode" placeholder="协议编码" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="负责人:">
          <el-input size="small" v-model="dataForm.partyaRepresentive" placeholder="负责人" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="协议状态:">
          <el-select size="small" v-model="dataForm.agreementStatus" placeholder="请选择状态" clearable @change="getDataList">
            <el-option v-for="item in AGREEMENT_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="协议类型:">
          <el-select size="small" v-model="dataForm.agreementType" placeholder="请选择类型" clearable @change="getDataList">
            <el-option v-for="item in AGREEMENT_TYPE" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="getDataList()" icon="el-icon-search">
            查询
          </el-button>
        </el-form-item><br>
        <el-form-item label="供应商编码:">
          <el-input size="small" v-model="dataForm.partybCode" placeholder="供应商编码" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="甲方:" label-width="57px">
          <el-input size="small" v-model="dataForm.purchasePartya" placeholder="甲方" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="乙方:" label-width="71px">
          <el-input size="small" v-model="dataForm.supplierPartyb" placeholder="乙方" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item class="fr">
          <el-button size="small" plain v-if="isAuth('sourcing:priceAgreement:newbutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
            新建价格协议
          </el-button>
          <el-button size="small" plain type="warning" icon="el-icon-plus" @click="pushSaps()">
            批量推送SAP
          </el-button>
        </el-form-item>
      </el-form>
      <div v-loading="dataListLoading">
        <el-table :header-cell-style="{background:'#f5f5f5'}"  @selection-change="selectionChangeHandle" :data="dataList" row-key="id" size="small" bPriceAgreement style="width: 100%;" :default-expand-all="false" border :height="tableHeight">
          <el-table-column type="selection" :selectable='checkboxSelect' width="55">
          </el-table-column>
          <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column prop="priceAgreementCode" header-align="center" align="left" label="协议编码" width="150">
          </el-table-column>
          <el-table-column prop="agreementType" header-align="center" align="center" label="协议类型" width="150">
            <template slot-scope="scope">
              {{ getAgreementTypeByValue(scope.row.agreementType) }}
            </template>
          </el-table-column>
          <el-table-column prop="agreementStatus" header-align="center" align="center" label="协议状态" width="150">
            <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.agreementStatus)">
                            {{ agreementStatusFormat(scope.row.agreementStatus) }}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="taxRate" header-align="center" align="center" label="增值税税率" width="100">
            <template slot-scope="scope">
              <span>{{getTaxCodeName(scope.row.taxRate)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payPeriod" header-align="center" align="center" label="账期" width="200">
            <template slot-scope="scope">
              {{ getPayPeriodValue(scope.row.payPeriod) }}
            </template>
          </el-table-column>
          <el-table-column prop="payWay" header-align="center" align="center" label="付款方式" width="150">
            <template slot-scope="scope">
              {{ getPayWayValue(scope.row.payWay) }}
            </template>
          </el-table-column>
          <el-table-column prop="purchasePartya" header-align="center" align="left" label="甲方" width="280">
          </el-table-column>
          <el-table-column prop="partyaSignDate" header-align="center" align="right" label="甲方签订日" :formatter="dateFormat" width="170">
          </el-table-column>
          <el-table-column prop="supplierPartyb" header-align="center" align="left" label="乙方" width="280">
          </el-table-column>
          <el-table-column prop="partybSignDate" header-align="center" align="right" label="乙方签订日" :formatter="dateFormat" width="170">
          </el-table-column>
          <el-table-column prop="partybCode" header-align="center" align="left" label="供应商编码" width="150">
          </el-table-column>
          <el-table-column prop="validityOfContract" header-align="center" align="left" label="协议有效期" width="300">
            <template slot-scope="scope">
                        <span v-if="scope.row.contractStartDate && scope.row.contractEndDate">
                            {{scope.row.contractStartDate}} - {{scope.row.contractEndDate}}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" header-align="center" align="right" label="创建时间" width="170">
          </el-table-column>
          <el-table-column prop="unQuoteReason" header-align="center" align="right" label="驳回原因" width="200">
          </el-table-column>
          <el-table-column prop="pic" header-align="center" align="center" width="120" label="当前流程图示">
            <template slot-scope="scope">
              <el-link type="primary" style="font-size: 12px;" @click="viewDiagram(scope.row)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="createBy" header-align="center" align="center" label="审批历史" width="120">
            <template slot-scope="scope">
              <el-button @click="doHistory(scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                查看
              </el-button>
              <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                修改
              </el-button>
              <el-button :disabled="scope.row.syncStatus == 1 ? true : false" type="text" size="small" @click="pushSap(scope.row)" icon="el-icon-edit">
                同步
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>

      <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
        <div v-for="str in historyList" :key="str">
          <el-descriptions :title="str.executeTime">
            <el-descriptions-item label="审批类型">{{str.taskName}}</el-descriptions-item>
            <el-descriptions-item label="审批结果">{{str.executeName}}</el-descriptions-item>
          </el-descriptions>
          <el-divider></el-divider>
        </div>
      </el-drawer>

      <!-- 保留原有的图片查看对话框（兼容旧功能） -->
      <el-dialog :visible.sync="showViewer" width="80%" title="流程图">
        <el-image :src="diagramUrl" style="margin-bottom: 120px;">
        </el-image>
      </el-dialog>

      <!-- 新增：审批进度对话框 -->
      <el-dialog :visible.sync="showWorkflowDialog" width="70%" title="审批进度" :close-on-click-modal="false">
        <div class="workflow-container">
          <div class="workflow-steps">
            <!-- 节点 1: 提交价格协议 -->
            <div class="step" :class="getStepClass(1)">
              <div class="step-circle">1</div>
              <div class="step-label">提交价格协议</div>
              <div class="step-status">{{ getStepStatusText(1) }}</div>
            </div>

            <!-- 连线 1→2 -->
            <div class="step-line" :class="getLineClass(1, 2)"></div>

            <!-- 节点 2: 供应商管理员审批 -->
            <div class="step" :class="getStepClass(2)">
              <div class="step-circle">2</div>
              <div class="step-label">供应商管理员审批</div>
              <div class="step-status">{{ getStepStatusText(2) }}</div>
            </div>

            <!-- 连线 2→3 -->
            <div class="step-line" :class="getLineClass(2, 3)"></div>

            <!-- 节点 3: 流程结束 -->
            <div class="step" :class="getStepClass(3)">
              <div class="step-circle">3</div>
              <div class="step-label">流程结束</div>
              <div class="step-status">{{ getStepStatusText(3) }}</div>
            </div>
          </div>

          <!-- 当前状态说明 -->
          <div class="current-status">
            <h4>当前状态：{{ getCurrentStatusText() }}</h4>
            <p>{{ getCurrentStatusDesc() }}</p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getTaxCodeList
} from '@/controller/systemData'
import {
  getPriceAgreementList,
  removePriceAgreement,
  exportPriceArgument,
  pushSapBackPrice,
} from '@/controller/priceAgreement'
import {
  listAllStatus,
  getProcessDiagramCurrent,
  listCommentHistory
} from '@/controller/workflow'
import {
  AGREEMENT_STATUS,
  getLabelByValue,
  AGREEMENT_TYPE,
  getAGREEMENT_TYPE_VALUE,
  getPAY_WAY_VALUE,
  getPAY_PERIOD_VALUE,
} from '@/utils/const'
import AddOrUpdate from './price-aggreement-add-or-update'
import moment from 'moment'

export default {
  data() {
    return {
      documentClientHeight: document.documentElement['clientHeight'] - 250,
      dataForm: {
        priceAgreementCode: '',
        partyaRepresentive: '',
        agreementStatus: '',
        agreementType: '',
        partybCode: '',
        purchasePartya: '',
        supplierPartyb: ''
      },
      dataList: [],
      tenantList: [],
      taxCodeList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      // 协议类型
      AGREEMENT_STATUS: AGREEMENT_STATUS,
      getLabelByValue: getLabelByValue,
      // 协议状态
      AGREEMENT_TYPE: AGREEMENT_TYPE,
      getAgreementTypeByValue: getAGREEMENT_TYPE_VALUE,
      getPayWayValue: getPAY_WAY_VALUE,
      getPayPeriodValue: getPAY_PERIOD_VALUE,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      // 审批历史
      drawer: false,
      // 审批列表
      historyList: [],
      showViewer: false,
      diagramUrl: '',

      // 新增：工作流相关
      showWorkflowDialog: false,  // 控制工作流对话框显示
      currentWorkflowStatus: '', // 当前审批状态
      statusPriority: {
        '提交价格协议': 1,
        '供应商管理员审批': 2,
        '流程结束': 3,
        '已同步': 4
      }
    }
  },
  computed: {
    tableHeight: {
      get() {
        return this.$store.state.common.documentClientHeight - 270
      }
    }
  },
  components: {
    AddOrUpdate
  },
  activated() {
    this.getDataList()
    this.getTaxCodeList()
  },
  methods: {
    // 审批历史
    doHistory(row) {
      this.historyList = []
      listCommentHistory({
        'workflowId': row.workflowId
      }).then(data => {
        if (data && data.code === '00') {
          this.historyList = data.body
        } else {
          this.$message.error(data.msg)
        }
      })
      this.drawer = true
    },

    // 修改后的viewDiagram方法 - 使用新的审批进度展示
    viewDiagram(row) {
      console.log('viewDiagram', row)
      // 直接从行数据中获取状态和workflowId
      if (row && row.agreementStatus) {
        this.currentWorkflowStatus = row.agreementStatus;
        this.showWorkflowDialog = true;
      } else {
        this.$message.warning('无法获取流程信息');
      }
    },

    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date == undefined) {
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },

    // 协议类型
    agreementTypeFormat: function (value) {
      if (!value) {
        return ''
      }
      return getAGREEMENT_TYPE_VALUE(AGREEMENT_TYPE, value)
    },

    // 协议状态
    agreementStatusFormat: function (value) {
      if (!value) {
        return ''
      }
      return getLabelByValue(AGREEMENT_STATUS, value)
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      getPriceAgreementList({
        pageSize: this.pageSize,
        pageNo: this.pageIndex,
        'priceAgreementCode': this.dataForm.priceAgreementCode,
        'partyaRepresentive': this.dataForm.partyaRepresentive,
        'agreementStatus': this.dataForm.agreementStatus,
        'agreementType': this.dataForm.agreementType,
        'partybCode': this.dataForm.partybCode,
        'purchasePartya': this.dataForm.purchasePartya,
        'supplierPartyb': this.dataForm.supplierPartyb
      }).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.records
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.dataListLoading = false
      })
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },

    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },

    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },

    // 查看
    viewHandle(row) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
      })
    },

    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
      })
    },

    // 删除
    deleteHandle(id) {
      console.log(id)
      this.$confirm(`确定进行删除操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removePriceAgreement({}, id).then(data => {
          if (data && data.code === '00') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },

    //获取税码信息
    getTaxCodeList() {
      getTaxCodeList({
        taxCode: "",
        taxRate: ""
      }).then(data => {
        if (data && data.code === '00') {
          this.taxCodeList = data.body;
        }
      })
    },

    getTaxCodeName(code) {
      const taxCode = this.taxCodeList.find(taxCode => taxCode.taxCode === code)
      return taxCode ? taxCode.taxRate : ''
    },

    exportData(rec) {
      exportPriceArgument(rec).then(data => {
        if (data && data.code === '00') {
          this.readAsBinaryString(data.body)
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              // this.getDataList()
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    },

    readAsBinaryString(data) {
      const blob = this.str2Blob(data.content, 'application/msword;charset=utf-8');
      const url = window.URL.createObjectURL(blob);
      let dom = document.createElement('a');
      dom.style.display = 'none';
      dom.href = url;
      dom.setAttribute('download', decodeURI(data.fileName));
      document.body.appendChild(dom);
      dom.click();
    },

    str2Blob(str, mime) {
      var arr = str.split(',')
      var bstr = atob(arr[0]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },

    //禁用checkbox
    checkboxSelect (row, rowIndex) {
      if (row.syncStatus == 1) {
        return false
      }else{
        return true
      }
    },

    //推送sap
    pushSaps(){
      if(this.dataListSelections.length == 0){
        this.$message.warning("请选择数据")
        return
      }
      this.$confirm('当前共选中'+this.dataListSelections.length+'条数据进行批量推送。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = [];
        for (let index = 0; index < this.dataListSelections.length; index++) {
          ids.push(this.dataListSelections[index].id);
        }
        pushSapBackPrice(ids).then(data => {
          if(data.code === '00'){
            this.$message.success({
              message: '推送完成',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
                this.$emit("refreshDataList")
              }
            })
          }else{
            this.$message.error(data.msg);
          }
        })
      })
    },

    pushSap(row){
      const ids = [];
      ids.push(row.id);
      pushSapBackPrice(ids).then(data => {
        if(data.code === '00'){
          this.$message.success({
            message: '推送完成',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getDataList()
              this.$emit("refreshDataList")
            }
          })
        }else{
          this.$message.error(data.msg);
        }
      })
    },

    getStatusClass(status) {
      let className = ''
      switch (status) {
        case '提交价格协议':
          className = "text-primary"
          break;
        default:
          className = 'text-success'
          break;
      }
      return className
    },

    // 新增：工作流相关方法
    // 获取步骤状态
    getStepStatus(step) {
      const status = this.currentWorkflowStatus;
      const priority = this.statusPriority[status] || 0;

      // 定义各状态的预期流程 - 根据实际的协议状态调整
      const statusSequence = [
        { step: 1, name: '提交价格协议', requiredStatus: '提交价格协议' },
        { step: 2, name: '供应商管理员审批', requiredStatus: '供应商管理员审批' },
        { step: 3, name: '流程结束', requiredStatus: '流程结束' }
      ];

      // 找到当前步骤对应的配置
      const currentStepConfig = statusSequence.find(s => s.step === step);
      if (!currentStepConfig) return 'pending';

      // 如果当前状态等于该步骤的状态，则为进行中
      if (status === currentStepConfig.requiredStatus) {
        return 'current';
      }

      // 如果当前状态优先级高于该步骤的状态，则为已完成
      if (priority > this.statusPriority[currentStepConfig.requiredStatus]) {
        return 'completed';
      }

      // 否则为待处理
      return 'pending';
    },

    // 获取步骤样式类
    getStepClass(step) {
      const status = this.getStepStatus(step);
      return {
        'step-completed': status === 'completed',
        'step-current': status === 'current',
        'step-pending': status === 'pending'
      };
    },

    // 获取连线样式类
    getLineClass(fromStep, toStep) {
      const fromStatus = this.getStepStatus(fromStep);
      const toStatus = this.getStepStatus(toStep);

      // 如果前一个节点已完成，连线显示为完成状态
      if (fromStatus === 'completed' && (toStatus === 'current' || toStatus === 'completed')) {
        return 'line-completed';
      }
      // 如果前一个节点是进行中，且后一个节点是当前节点
      else if (fromStatus === 'current' && toStatus === 'current') {
        return 'line-active';
      }
      return 'line-pending';
    },

    // 获取步骤状态文本
    getStepStatusText(step) {
      const status = this.getStepStatus(step);
      switch (status) {
        case 'completed':
          return '✓ 已完成';
        case 'current':
          return '▶ 进行中';
        case 'pending':
          return '○ 待处理';
        default:
          return '';
      }
    },

    // 获取当前状态文本
    getCurrentStatusText() {
      const statusMap = {
        '提交价格协议': '草稿状态',
        '供应商管理员审批': '等待供应商管理员审批',
        '流程结束': '流程已完成',
      };
      return statusMap[this.currentWorkflowStatus] || this.currentWorkflowStatus;
    },

    // 获取当前状态描述
    getCurrentStatusDesc() {
      const descMap = {
        '提交价格协议': '协议已创建，处于草稿状态',
        '供应商管理员审批': '协议已提交，等待供应商管理员审批',
        '流程结束': '所有审批环节已完成，协议生效',
      };
      return descMap[this.currentWorkflowStatus] || '暂无状态描述';
    }
  }
}
</script>

<style scoped>
/* 工作流样式 */
.workflow-container {
  padding: 20px;
}

.workflow-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 40px 0;
  padding: 0 20px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  min-width: 120px;
}

.step-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e4e7ed;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  border: 3px solid #e4e7ed;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.step-label {
  font-size: 14px;
  color: #303133;
  text-align: center;
  font-weight: 500;
  margin-bottom: 5px;
  padding: 0 5px;
}

.step-status {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

/* 步骤状态样式 */
.step-completed .step-circle {
  background: #67c23a;
  color: white;
  border-color: #67c23a;
}

.step-current .step-circle {
  background: #409eff;
  color: white;
  border-color: #409eff;
  animation: pulse 2s infinite;
}

.step-pending .step-circle {
  background: #e4e7ed;
  color: #606266;
  border-color: #e4e7ed;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(64, 158, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

/* 连线样式 */
.step-line {
  flex: 1;
  height: 4px;
  background: #e4e7ed;
  margin: 0 10px;
  position: relative;
  top: -22px;
  transition: all 0.3s ease;
}

.line-completed {
  background: #67c23a;
}

.line-active {
  background: linear-gradient(90deg, #67c23a 0%, #409eff 100%);
}

.line-pending {
  background: #e4e7ed;
}

/* 当前状态说明 */
.current-status {
  margin-top: 40px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  border-left: 4px solid #409eff;
}

.current-status h4 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 16px;
}

.current-status p {
  margin: 0;
  color: #606266;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .workflow-steps {
    flex-direction: column;
    gap: 30px;
  }

  .step-line {
    width: 4px;
    height: 40px;
    margin: 10px 0;
    top: 0;
  }
}
</style>